
// year titles
class YearTitles {
  static from(array) {
    console.log("YEAR FROM", array)
    var values = []
    if (array != undefined) {
      values = array.map(object => {
        return new YearTitles(object)
      });
    }

    return values
  }

  constructor(initializer) {
    this.value = initializer.value;
    this.title = initializer.title;
  }

  static KEY_STRING = "year_titles"
}

// outcome config
class OutcomeConfiguration {
  static from(object) {
    try {
      return new OutcomeConfiguration(object);
    } catch (err) {
      console.log("error - no criteria", err);
      return err;
    }
  }

  constructor(initializer) {
    this.id = initializer.id;
    this.active = initializer.values.active;
  }

  valuesAsJSON() {
    return JSON.stringify({
      active: this.active
    });
  }

  //static KEY_STRING = "outcome_config"
}

// lesson form fields
class Field {
  static from(object) {
    try {
      return new Field(object);
    } catch (err) {
      console.log("error - no field", err);
      return err;
    }
  }

  constructor(initializer) {
    this.name = initializer.name;
    this.value = initializer.value;
    this.order = initializer.order;
    this.used = initializer.used;
    this.protect = initializer.protect;
    this.model = initializer.model;
    this.filebased = initializer.filebased
    this.popover = initializer.popover

  }
}

class Fields {
  static from(object) {
    try {
      return new Fields(object);
    } catch (err) {
      console.log("error - no criteria", err);
      return err;
    }
  }


  static from(array) {
    var values = Fields.defaultValues()
    if (array != undefined) {
      values = array.map(object => {
        return Field.from(object)
      });
    }

    return _.orderBy(values, ["order", "name"]);
  }


  orderedFields(data) {
    let values = data.map(field => {
      return Field.from(field);
    });
    return _.orderBy(values, ["order", "name"]);
  }

  static defaultValues() {
    return [
      Field.from({
        name: "Outline",
        order: 1,
        used: true,
        protect: true,
        model: "outline",
        filebased: true,
        popover: false,
        dance: "Lesson Outline / Objectives",
        cross: "Lesson Outcome"
      }),
      Field.from({ name: "Introduction", order: 2, used: true, model: "introduction", popover: true, dance: "Introduction", cross: "Lesson Outline"}),
      Field.from({ name: "Warm-Up", order: 3, used: true, model: "warm-up", popover: false, dance: "Introduce and Reinforce" }),
      Field.from({
        name: "Main Session",
        order: 4,
        used: true,
        protect: true,
        model: "main-session",
        filebased: true,
        popover: false,
        dance: "Explore and Establish",
        cross: "Lesson Slides"
      }),
      Field.from({ name: "Game Session", order: 5, used: true, model: "game-session", popover: false, dance: "Develop and Create" }),
      Field.from({ name: "Competition", order: 6, used: false, model: "competition", popover: false, dance: "Competition", cross: "Lesson Summary" }),
      Field.from({
        name: "Performance",
        order: 7,
        used: false,
        model: "performance",
        popover: false,
        dance: "Performance",
      }),
      Field.from({ name: "Health & Wellbeing", order: 8, used: false, model: "health", popover: false, dance: "Health & Wellbeing" }),
      Field.from({
        name: "Collaboration",
        order: 9,
        used: false,
        model: "collaboration",
        popover: false,
        dance: "Collaboration"
      }),
      Field.from({ name: "Conclusion", order: 10, used: true, model: "conclusion", popover: false, dance: "Perform and Review" }),
      Field.from({ name: "Activities", order: 11, used: true, model: "activities", popover: true, dance: "Activities" })
    ];
  }

  static KEY_STRING = "course_fields"
}

export { Fields, OutcomeConfiguration, YearTitles };
